var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"h-100 container-fluid"},[_vm._t("default"),_c('ModalNotification',{attrs:{"id":"default-modal-notification"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }